import { useEffect, useState } from 'react';
import ToggleButton from '../UI/ToggleButton';
import { API_ENDPOINTS } from '../../Config/api';
import useGet from '../../Hooks/useGet';
import flatEndpoints from '../../Utils/flatEndpoints';
import formatDate from '../../Utils/formatDate';
import usePut from '../../Hooks/usePut';
import { toast } from 'react-toastify';
import DynamicTable from '../UI/DynamicTable';
import { useTranslation } from 'react-i18next';

export default function EndpointsTable() {
  const { fetchedData, loading, error } = useGet(API_ENDPOINTS.endpointList);
  const { putData } = usePut();
  const { t } = useTranslation();

  const [search, setSearch] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [data, setData] = useState(flatEndpoints([]));

  useEffect(() => {
    if (fetchedData) {
      setData(flatEndpoints(fetchedData));
    }
  }, [fetchedData]);


  const filteredData = data.filter((item) => {

    const lowerCaseSearch = search.toLowerCase();
    const matchesSearch =
      (item.email ?? '').toLowerCase().includes(lowerCaseSearch) ||
      (item.file_angel_code ?? '').toLowerCase().includes(lowerCaseSearch) ||
      (item.browsing_angel_code ?? '').toLowerCase().includes(lowerCaseSearch) ||
      (formatDate(item.timestamp_attivazione) ?? '').toLowerCase().includes(lowerCaseSearch);

    const isActive = isStatusActive(item.stato_endpoint);
    const matchesStatus =
      statusFilter === 'all' ||
      (statusFilter === 'active' && isActive) ||
      (statusFilter === 'inactive' && !isActive);

    return matchesSearch && matchesStatus;
  });

  const toggleStatus = async (row) => {
    ;
  const newState = isStatusActive(row.stato_endpoint) ? 'DISATTIVO' : 'ATTIVO';
  const payload = { stato_endpoint: newState };

    try {
      await putData(
        API_ENDPOINTS.endpointStateUpdate(row.id_endpoint),
        payload
      );
      setData((prevData) =>
        prevData.map((item) =>
          item.id_endpoint === row.id_endpoint
            ? { ...item, stato_endpoint: newState }
            : item
        )
      );
      toast.success(
        t(newState === 'ATTIVO' ? 'endpoints.toastActivated' : 'endpoints.toastDeactivated')
      );
    } catch (err) {
      const errorMessage =
        err.response?.data?.detail ||
        t('endpoints.toastErrorLimit');
      toast.error(errorMessage);
      console.error('Errore durante l\'aggiornamento dello stato:', err);
    }
  };


  function isStatusActive(status) {
    return status.toUpperCase() === 'ATTIVO';
  }

  const filterOptions = [
    { value: 'all', label: t('endpoints.filterAll') },
    { value: 'active', label: t('endpoints.filterActive') },
    { value: 'inactive', label: t('endpoints.filterInactive') }
  ];

  return (
    <div>

      <DynamicTable
        data={filteredData}
        customColumnsMap={[
          {
            field: 'email',
            label: t('endpoints.colEmail'),
            width: 'w-48'
          },
          {
            label: t('endpoints.colStatus'),
            width: 'w-48',
            align: 'left',
            render: (row) => (
              <div className={`w-32 py-1 text-center rounded ${row.stato_endpoint.toUpperCase() === 'ATTIVO' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
                {row.stato_endpoint.toUpperCase() === 'ATTIVO' ? t('endpoints.statusActive') : t('endpoints.statusInactive')}
              </div>
            )
          },
          {
            label: t('endpoints.colActivationDate'),
            width: 'w-48',
            align: 'left',
            render: (row) => (
              <p>{row.timestamp_attivazione ? formatDate(row.timestamp_attivazione) : '-'}</p>
            )
          },
          {
            label: t('endpoints.colFileAngelCode'),
            width: 'w-48',
            align: 'left',
            render: (row) => (
              <p>{row.file_angel_code ? row.file_angel_code : '-'}</p>
            )
          },
          {
            label: t('endpoints.colBrowsingAngelCode'),
            width: 'w-48',
            align: 'left',
            render: (row) => (
              <p>{row.browsing_angel_code ? row.browsing_angel_code : '-'}</p>
            )
          },
          {
            label: t('endpoints.colActions'),
            width: 'w-24',
            align: 'right',
            render: (row) => (
              <ToggleButton
                checked={row.stato_endpoint.toUpperCase() === 'ATTIVO'}
                onToggle={() => toggleStatus(row)}
              />
            )
          },
        ]}
        searchTerm={search}
        onSearchChange={setSearch}
        searchKeys={['asset', 'tipo_asset']}
        enableRowSelection={false}
        showSearchBar={true}
        maxHeight="40rem"
        filterOptions={{ key: 'stato_endpoint', options: filterOptions }}
        filterValue={statusFilter}
        onFilterChange={setStatusFilter}
      />
    </div>
  );
}